import ErrorBox from '@components/common/ErrorBox';
import classNames from 'classnames';
import Button from '@ui/button/Button';
import DwFormField from '@ui/formfield/DwFormField';
import analytics from '@utils/analytics';
import api from '@utils/api';
import { BAA } from '@utils/constants';
import formutils from '@utils/formutils';
import createDecorator from 'final-form-focus';
import React, { useEffect, useRef, useState } from 'react';
import { Form } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import Tooltip from '@ui/tooltip/Tooltip';
import LiveBoutiqueConfirmationModal from './LiveBoutiqueConfirmationModal';
import BookAnAppointmentDateSelection from './BookAnAppointmentDateSelection';
import BookAnAppointmentReasonMessage from './BookAnAppointmentReasonMessage';
import DwFormFieldPhoneWithPrefix from '@ui/formfield/DwFormFieldPhoneWithPrefix';
const focusOnError = createDecorator(); // must be outside the component
const LiveBoutiqueForm = (props) => {
    const { t } = useTranslation();
    const [requestSent, setRequestSent] = useState();
    const [appointmentresponse, setAppointmentresponse] = useState();
    const [formdef, setFormdef] = useState();
    const [initialValues, setInitialValues] = useState();
    const [errors, setErrors] = useState([]);
    const [days, setDays] = useState({});
    const [store, setStore] = useState(props.store);
    const [appointmentType, setAppointmentType] = useState(BAA.APPOINTMENT.VIRTUAL);
    const [collections, setCollections] = useState([]);
    const [profile, setProfile] = useState();
    const appointmentSection = useRef(null);
    const tabsMap = {
        '552250000': t('bookanappointment.appointmentinstoreanalytics'),
        '552250001': t('bookanappointment.virtualappointmentanalytics'),
    };
    useEffect(() => {
        var _a;
        api.searchStoreDetails((_a = props.store) === null || _a === void 0 ? void 0 : _a.ID).then((data) => {
            setStore(data);
        });
    }, [props.store]);
    useEffect(() => {
        let isMounted = true;
        let val = {};
        api.getForm('bookanappointment', val, true).then((data) => {
            var _a;
            if (!val.appointmenttype) {
                val.appointmenttype = BAA.APPOINTMENT.VIRTUAL;
            }
            if (props.type == 'mbm' && !val.reason) {
                val.reason = BAA.REASONS.PERSONALIZATION;
            }
            // filtra la personalization reason in base alla global preference activateMbmReasonContact
            if (!window.mbmContactReason) {
                data.reason.options = data.reason.options.filter((o) => o.value != BAA.REASONS.PERSONALIZATION);
            }
            // store without personalization room, filter it out from reasons
            if (props.type == 'modal' && !((_a = store === null || store === void 0 ? void 0 : store.storeServices) === null || _a === void 0 ? void 0 : _a.personalizationRoom)) {
                data.reason.options = data.reason.options.filter((o) => o.value != BAA.REASONS.PERSONALIZATION);
            }
            if (isMounted) {
                if (appointmentType != val.appointmenttype) {
                    setAppointmentType(val.appointmenttype);
                }
                setInitialValues(val);
                setFormdef(data);
            }
        });
        api.getProfile().then((data) => {
            setProfile(data);
        });
        return () => {
            isMounted = false;
        };
    }, []);
    useEffect(() => {
        if (store) {
            api.bookAnAppointmentSlots(store === null || store === void 0 ? void 0 : store.ID, appointmentType).then((data) => {
                setDays(data.days);
                if (props.type != 'mbm') {
                    api.bookAnAppointmentCollections(store === null || store === void 0 ? void 0 : store.ID).then((data) => {
                        setCollections(data);
                    });
                }
            });
        }
    }, [store, appointmentType]);
    const prefillValues = (values) => {
        values.storeid = store === null || store === void 0 ? void 0 : store.ID;
        if (window.loggedin) {
            values.privacyFlag = true;
            values.email = profile.email;
            values.firstname = profile.firstName;
            values.lastname = profile.lastName;
            if (profile.phone) {
                values.phone = profile.phone.toString();
            }
        }
        if (values.appointmenttype == BAA.APPOINTMENT.VIRTUAL && values.reason == BAA.REASONS.PERSONALIZATION) {
            values.reason = undefined;
        }
    };
    const validate = async (values) => {
        prefillValues(values);
        return await formutils.validateForm(values, formdef, 'bookanappointment');
    };
    const onSubmit = async (values) => {
        setErrors([]);
        let err = await validate(values);
        if (err && Object.keys(err).length > 0) {
            return err;
        }
        await api.bookAnAppointmentSubmit(values, formdef).then((data) => {
            // console.log('after submit: ' + JSON.stringify(data, null, 2));
            if (typeof data === 'undefined') {
                // -- setShowOverlay(false) if same appointment ?
                return;
            }
            if (data.error && data.error.length > 0) {
                setErrors(data.error);
                return;
            }
            // https://jira.industries-group.com/browse/MOM-3264
            // let errors: models.ValidationErrors = {};
            // if (!formutils.checkValidationAfterSubmit(data, errors)) {
            //   return errors;
            // }
            if (props.type != 'mbm') {
                // -- not mbm
                // analytics.bookAppointmentSubmit(props.product?.masterId);
                analytics.storelocatorBookAppointment(['modal', 'mbm'].includes(props.type) ? 'storelocator' : 'footer', `submit-moncler ${store.name}`);
            }
            setRequestSent(values);
            setAppointmentresponse(data);
            document.querySelector('.myaccount-hero').scrollIntoView({ behavior: 'smooth', inline: 'end' });
        });
    };
    if (formdef && store && requestSent && appointmentresponse) {
        return React.createElement(LiveBoutiqueConfirmationModal, { store: store, formdef: formdef, requestSent: requestSent, appointmentresponse: appointmentresponse, days: days });
    }
    if (!formdef || !initialValues || !store || !profile) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "modal__header-sticky" },
            React.createElement("h1", { className: "dialog__title" }, t('bookanappointment.title')),
            React.createElement("h2", { className: "mt-24" }, t('bookanappointment.liveboutique'))),
        React.createElement("div", { className: classNames('mt-24 mb-12') },
            React.createElement("div", { className: "live-boutique-selected-store" },
                store.liveBoutique && (React.createElement("div", { className: "live-boutique" },
                    React.createElement("span", { className: "primary-xxs" }, t('bookanappointment.liveboutique').toUpperCase()),
                    !store.liveBoutique && (React.createElement(Tooltip, { ariaLabel: t('label.info'), checkout: true, id: `${store.ID}-live-boutique-info`, icon: "info", className: "live-boutique-info", text: t('bookanappointment.liveboutiquetoltip', { 0: window.liveBoutiqueUrl }) })))),
                React.createElement("p", { className: "name bold primary-s" }, store.name),
                React.createElement("p", { className: "content" },
                    store.address1,
                    " ",
                    store.address2,
                    " ",
                    store.city))),
        React.createElement("div", { ref: appointmentSection, className: "product-reserve__detail__form mb-32" },
            React.createElement(Form, { initialValues: initialValues, onSubmit: onSubmit, validate: validate, decorators: [focusOnError], mutators: { global: formutils.globalMutator,
                    resetHours: (args, state, utils) => {
                        utils.changeValue(state, 'hour', () => null);
                    } }, render: ({ handleSubmit, form, submitting, pristine, values }) => (React.createElement("form", { onSubmit: handleSubmit },
                    React.createElement("div", { className: "ReserveForm" },
                        React.createElement(BookAnAppointmentDateSelection, { formdef: formdef, form: form, days: days, values: values, fullWidth: true }),
                        React.createElement("div", { className: "row" },
                            React.createElement("div", { className: 'col-12' },
                                React.createElement(DwFormField, { def: formdef, name: "reason", type: "select", options: values.appointmenttype != BAA.APPOINTMENT.VIRTUAL
                                        ? formdef.reason.options
                                        : formdef.reason.options.filter((o) => o.value != BAA.REASONS.PERSONALIZATION) })),
                            values.reason == BAA.REASONS.DISCOVERCOLLECTION && (collections === null || collections === void 0 ? void 0 : collections.length) > 0 && (React.createElement("div", { className: 'col-12' },
                                React.createElement(DwFormField, { def: formdef, name: "collectionCode", type: "select", options: [{ value: '', label: t('label.select') }].concat(collections) || [] })))),
                        React.createElement(BookAnAppointmentReasonMessage, { formdef: formdef, values: values }),
                        React.createElement("div", { className: "row profile mt-32 mb-24" },
                            React.createElement("div", { className: "col-12 mb-16" },
                                React.createElement("h4", { className: "label text-uppercase mb-8" }, t('profile.namesurname')),
                                React.createElement("p", { className: "bold primary-s" },
                                    profile.firstName,
                                    " ",
                                    profile.lastName)),
                            React.createElement("div", { className: "col-12 mb-16" },
                                React.createElement("h4", { className: "label text-uppercase mb-8" }, t('bookanappointment.email')),
                                React.createElement("p", { className: "bold primary-s" }, profile.email)),
                            profile.phone ? (React.createElement("div", { className: "col-12" },
                                React.createElement("h4", { className: "label text-uppercase mb-8" }, t('bookanappointment.phone')),
                                React.createElement("p", { className: "bold" },
                                    profile.phonePrefix,
                                    " ",
                                    profile.phone))) : (React.createElement("div", { className: "form-number" },
                                React.createElement("div", { className: "mb-12" },
                                    React.createElement("span", { className: "primary-xs" }, t('profile.additionalinfo'))),
                                React.createElement(DwFormFieldPhoneWithPrefix, { def: formdef, uniqueLabel: t('profile.phonenumber') })))),
                        store.countryCode.value !== window.country && (React.createElement("div", { className: "row" },
                            React.createElement("p", { className: "disclaimer mt-12 mb-12" }, t('liveboutique.disclaimer'))))),
                    React.createElement("div", { className: "product-reserve__detail__form__submit" },
                        React.createElement(Button, { type: "submit", disabled: submitting, cls: ['button--primary'], onClick: () => {
                                analytics.clientServiceRedesignAnalytics(`${props.pagetitleforanalytics}`, tabsMap[appointmentType.toString()].toLowerCase() + '-' + t('bookanappointment.confirmappointmentanalytics').toLowerCase());
                            } }, t('bookanappointment.confirmappointment'))),
                    React.createElement(ErrorBox, { errors: errors }))) }))));
};
export default LiveBoutiqueForm;
